import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { SeoLinkComponent } from 'dibs-seo/exports/SeoLink';
import { SEGMENTS } from 'dibs-constants/exports/uriConstants';

import { SbSharedStorefrontLink_browseContentModule } from './__generated__/SbSharedStorefrontLink_browseContentModule.graphql';

import styles from './SbSharedStorefrontLink.scss';

type Props = {
    browseContentModule: SbSharedStorefrontLink_browseContentModule;
};

const SbSharedStorefrontLinkComponent: FC<Props> = ({ browseContentModule }) => {
    const seller = browseContentModule.seller;
    const company = seller?.sellerProfile?.company;

    if (!seller || !company) {
        return null;
    }

    const urlLabel = seller.sellerPreferences?.urlLabel;
    const isLinkable = !!urlLabel && seller.liveStorefrontProfile?.status === 'LIVE';
    const path = isLinkable ? `/${SEGMENTS.SELLER}/${urlLabel}/` : null;

    return (
        <div className={styles.wrapper}>
            (
            <FormattedMessage
                id="SbSharedStorefrontLink.bioProvidedBy"
                defaultMessage="Biography provided by"
            />{' '}
            <SeoLinkComponent
                linkData={{
                    path,
                    isLinkable,
                }}
                dataTn="bio-seller-link"
            >
                {company}
            </SeoLinkComponent>
            )
        </div>
    );
};

export const SbSharedStorefrontLink = createFragmentContainer(SbSharedStorefrontLinkComponent, {
    browseContentModule: graphql`
        fragment SbSharedStorefrontLink_browseContentModule on ContentModuleRegular {
            seller {
                sellerProfile {
                    company
                }
                sellerPreferences {
                    urlLabel
                }
                liveStorefrontProfile {
                    status
                }
            }
        }
    `,
});
